import React from 'react';
import './ChooseLanguage.css';

import {xpressApi, GET_QUESTIONNAIRE} from '../../providers/xpress_api';
import {DotLoader} from 'react-spinners';
import Header from "../Common/Header/Header";
import Footer from "../Common/Footer/Footer";
import TranslationConstants from '../../model/TranslationConstants';
import {homePageGetStartedEnglish, homePageGetStartedSpanish} from "../../model/TranslationConstants";
import {PATH_PRESCREEN, XPRESS_STATE_BLOOD_CENTER_PROPERTIES, XPRESS_STATE_TRANSLATION_CONSTANTS, XPRESS_STATE_LANGUAGE, XPRESS_STATE_QUESTIONNAIRE, XPRESS_STATE_SEX_OPTIONS} from "../../App";

export default class ChooseLanguage extends React.Component
{
    constructor(props)
    {
        super(props);

        const defaultLanguage = '1'; // Default to English until the user selects a language

        this.state = {
            language: defaultLanguage,
            translationConstants: new TranslationConstants(defaultLanguage),
            loading: true,
            questionnaireAvailable: false
        }

        this.bloodCenterId = this.props.match.params.bcId;
        this.questionnaire = null;
        this.bloodCenterProperties = null;
    }

    async componentDidMount()
    {
        console.log("Loading questionnaire and translations for bloodCenterId=" + this.bloodCenterId);
        await this.getBloodCenterPropertiesAndQuestionnaire(this.bloodCenterId);

        if (this.questionnaire) {
            if(this.questionnaire.translationAvailable) {
                this.setState({
                    loading: false,
                    questionnaire: this.questionnaire,
                    bloodCenterProperties: this.bloodCenterProperties
                });
            }
            else {
                // No translations are available, so default to English and forward to the Prescreen page
                this.updateXpressStateValue(XPRESS_STATE_TRANSLATION_CONSTANTS, new TranslationConstants('1'));
                this.updateXpressStateValue(XPRESS_STATE_LANGUAGE, '1');

                this.props.history.push({
                    pathname: PATH_PRESCREEN.replace(':bcId', this.bloodCenterId)
                });
            }
        }
    };

    getBloodCenterPropertiesAndQuestionnaire = async (bloodCenterId) => {
        let response = await xpressApi.get(GET_QUESTIONNAIRE, {params: {bloodCenterId: bloodCenterId}});

        if (response.data && response.data.questionnaire && response.data.bloodCenterProperties) {
            this.questionnaire = response.data.questionnaire;
            this.bloodCenterProperties = response.data.bloodCenterProperties;

            this.updateXpressStateValue(XPRESS_STATE_QUESTIONNAIRE, this.questionnaire);
            this.updateXpressStateValue(XPRESS_STATE_BLOOD_CENTER_PROPERTIES, this.bloodCenterProperties);

            // Parse the blood center's sex options String into an object and store it in the state (HD #10194)
            const sexOptions = this.getSexOptions(this.bloodCenterProperties.sexOptions);
            this.updateXpressStateValue(XPRESS_STATE_SEX_OPTIONS, sexOptions);

            this.setState({questionnaireAvailable: true});
        }
        else {
            console.log("Failed to retrieve questionnaire for blood center");
            this.setState({loading: false, questionnaireAvailable: false});
        }
    };

    handleLanguageSelect = language => {
        this.updateXpressStateValue(XPRESS_STATE_TRANSLATION_CONSTANTS, new TranslationConstants(language));
        this.updateXpressStateValue(XPRESS_STATE_LANGUAGE, language);

        this.props.history.push({
            pathname: PATH_PRESCREEN.replace(':bcId', this.bloodCenterId)
        });
    };

    updateXpressStateValue = (key, value) => {
        this.props.fnUpdateXpressStateValue(key, value);
    }

    getSexOptions = (sexOptionsString) => {
        // Parses a delimited sex options String with the format "[Code]:[Translation ID]=[Translation Value];[Translation ID]=[Translation Value]|"
        const sexOptionsArray = sexOptionsString.split('|');

        let sexOptions = [];
        sexOptionsArray.forEach(sexOption => {
            const sexCode = sexOption.substring(0, sexOption.indexOf(':'));

            const sexDescriptionString = sexOption.substring(sexOption.indexOf(':') + 1);
            const sexDescriptionsArray = sexDescriptionString.split(';');

            let sexDescriptions = [];
            sexDescriptionsArray.forEach(sexDescription => {
                const translationId = sexDescription.substring(0, sexDescription.indexOf('='));
                const description = sexDescription.substring(sexDescription.indexOf('=') + 1);
                sexDescriptions.push({ translationId: translationId, description: description });
            });

            sexOptions.push({ code: sexCode, descriptions: sexDescriptions });
        });

        return sexOptions;
    }

    render() {
        if (this.state.loading) {
            return (
                <div className="pageWrapper">
                    <div className="contentWrapper">
                        <Header filler/>
                        <DotLoader css={"display: block; margin-top: 23vh; margin-left: auto; margin-right: auto;"} sizeUnit={"px"} size={100} color={'red'} loading={true}/>
                    </div>
                    <Footer text={this.state.translationConstants.xpressPoweredBy}/>
                </div>
            );
        }
        else if(this.state.questionnaireAvailable === false) {
            return (
                <div className="pageWrapper">
                    <div className="contentWrapper">
                        <Header/>
                        <div className="container">
                            <div className="row justify-content-center" style={{marginTop: '1rem', textAlign: 'center'}}>
                                <span className="chooseLanguageText" style={{marginBottom: '2rem'}}>Sorry, a questionnaire is not available at this time. Please contact your blood center for information.</span>
                                <span className="chooseLanguageText">Lo sentimos, un cuestionario no está disponible en este momento. Contacto con su centro de sangre para obtener información.</span>
                            </div>
                        </div>
                    </div>
                    <Footer text={this.state.translationConstants.xpressPoweredBy}/>
                </div>
            );
        }
        else {
            return (
                <div className="pageWrapper">
                    <div className="contentWrapper">
                        <Header logoPath={this.state.questionnaire.logoPath} taglinePath={this.questionnaire.taglinePath}/>
                        <div className="container">
                            <div className="row justify-content-center" style={{marginTop: '1rem', paddingBottom: '20px'}}>
                                <div className="col-md-6 text-center text-md-left my-auto">
                                    <span className="chooseLanguageText">{homePageGetStartedEnglish}</span>
                                </div>
                                <div className="col-md-1 text-center text-md-left">
                                    <button className="btn btn-primary chooseLanguageBtn" onClick={() => { this.handleLanguageSelect('1') }}>English</button>
                                </div>
                            </div>
                            <div className="row justify-content-center">
                                <div className="col-md-6 text-center text-md-left my-auto">
                                    <span className="chooseLanguageText">{homePageGetStartedSpanish}</span>
                                </div>
                                <div className="col-md-1 text-center text-md-left">
                                    <button className="btn btn-primary chooseLanguageBtn" type="button" onClick={() => { this.handleLanguageSelect('2') }}>Español</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer text={this.state.translationConstants.xpressPoweredBy}/>
                </div>
            );
        }
    }
}